import { createApi } from '@reduxjs/toolkit/query/react';
import { baseUsersV2Query } from './config';
import type { PlanVariant } from 'src/types/wallet/models/PlanVariant';
import { SnPlanVariantEntitlements } from 'src/types/models/SnPlanVariantEntitlements';

export interface EntitlementsRequest {
  plan_variant?: PlanVariant;
  user_id: string;
}

export enum EntitlementsTags {
  Entitlements = 'Entitlements',
}

export const entitlementsApi = createApi({
  reducerPath: 'entitlementsApi',
  baseQuery: baseUsersV2Query,
  tagTypes: [EntitlementsTags.Entitlements],
  endpoints: (builder) => ({
    getEntitlementsList: builder.query<
      SnPlanVariantEntitlements,
      EntitlementsRequest
    >({
      query: ({ plan_variant, user_id }) => ({
        url: `/plan_variants/${plan_variant}/entitlements`,
        params: {
          user_id,
        },
      }),
      providesTags: () => [EntitlementsTags.Entitlements],
      keepUnusedDataFor: 60 * 60 * 10,
    }),
  }),
});

export const { useGetEntitlementsListQuery } = entitlementsApi;
